// Copyright (c) 2019 Deere & Company

import './index.scss';

import React, { Component } from 'react';
import AuthenticatedPage from '../app/common/components/authenticated-page';
import PropTypes from 'prop-types';
import WarrantyProductStructureMaintenance from './components/warranty-product-stucture-maintenance';

class AdminPage extends Component {


    state= {
        navParameter: '',
    }


    componentWillReceiveProps ( nextProps ) {

        if ( nextProps.location.state === 'warranty' ) {

            this.setState( {
                navParameter: nextProps.location.state,
            } );

        }

    }

    updateReload = () => {

        this.setState( {
            navParameter: '',
        } );

    }

    render = () => (
        <AuthenticatedPage className="admin-page">
            <WarrantyProductStructureMaintenance
                reload={this.state.navParameter}
                updateReload={this.updateReload}
            />
        </AuthenticatedPage>
    )

}

AdminPage.displayName = 'AdminPage';
AdminPage.propTypes = {
    location: PropTypes.object.isRequired,
};

export default AdminPage;
